import React from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { History } from "history";
import _ from "lodash";
import { FormattedMessage } from "react-intl";

import Table from "components/Table";
import FieldChooser from "components/FieldChooser";
import TopButtons from "components/TopButtons";
import Button from "components/Button";
import SearchInput from "components/SearchInput";
import { ICultivationAdvice, ICommonState, IMeta } from "models/.";
import { getColumns } from "./columns";
import { URLS } from "constants/urlConstants";
import CultivationAdviceActions from "./actions";
import { CUSTOM_SETTINGS } from "constants/.";

interface IProps {
  intl: any;
  local: string;
  history: History;
  meta: IMeta;
  cultivationAdvices: ICultivationAdvice[];
  getCultivationAdvices: (meta?: IMeta) => void;
  onRemove: (ids: string[]) => void;
}

interface IState extends ICommonState {
  inputValue?: string;
}

class MyCultivationAdvice extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      showFieldChooser: false,
      columnsCopy: [],
      checkedRows: {},
      inputValue: ""
    };
  }

  public componentDidMount() {
    const { meta, getCultivationAdvices } = this.props;
    getCultivationAdvices();

    if (meta && meta.inputValue) {
      this.setState({
        inputValue: meta.inputValue
      });
    }
  }

  private handleSelect = () => {
    const ids = _.keys(this.state.checkedRows);
    this.props.onRemove(ids);
  };

  private handleFieldChooser = () => {
    this.setState(prevState => ({
      showFieldChooser: !prevState.showFieldChooser
    }));
  };

  private handleFieldsChange = columnsCopy => this.setState({ columnsCopy });

  private handleSearchChange = e => {
    const inputValue = e.target.value;

    this.setState({ inputValue }, this.search);
  };

  private search = _.debounce(() => {
    const { meta, getCultivationAdvices, local } = this.props;
    const { inputValue } = this.state;

    getCultivationAdvices({ ...meta, inputValue, local });
  }, 500);

  private onRowSelect = checkedRows => this.setState({ checkedRows });

  public render() {
    const {
      showFieldChooser,
      columnsCopy,
      checkedRows,
      inputValue
    } = this.state;
    const {
      cultivationAdvices,
      history,
      meta,
      local,
      intl,
      getCultivationAdvices
    } = this.props;

    return (
      <div id="my-teeltadvies-page">
        <div className="child-header">
          <FormattedMessage id="CULTIVATION_ADVICES" tagName="h1" />
          <Button
            kind="primary"
            className="animate-bg bg-white"
            onClick={() =>
              history.push(`${URLS.MY_CULTIVATION_ADVICE_URL}/new`)
            }
          >
            CULTIVATION_ADVICES_ADD
          </Button>
        </div>
        <SearchInput
          value={inputValue}
          placeholder="CULTIVATION_ADVICES_SEARCH"
          onChange={this.handleSearchChange}
        />
        <TopButtons
          options={[
            { value: "Delete", label: intl.formatMessage({ id: "REMOVE" }) }
          ]}
          handleFieldChooser={this.handleFieldChooser}
          handleSelect={this.handleSelect}
          entityName="cultivation-advice"
        />
        <Table
          columns={columnsCopy}
          dataSource={cultivationAdvices}
          onRowClick={rowData =>
            history.push(`${URLS.MY_CULTIVATION_ADVICE_URL}/${rowData._id}`)
          }
          meta={meta}
          onQueryChange={getCultivationAdvices}
          onRowSelect={this.onRowSelect}
          keyPath="_id"
          checkedRows={checkedRows}
          pageName={CUSTOM_SETTINGS.myCultivationAdvice}
        />
        <FieldChooser
          name="teeltadvies"
          visible={showFieldChooser}
          handleFieldChooser={this.handleFieldChooser}
          handleFieldsChange={this.handleFieldsChange}
          columns={getColumns(local)}
        />
      </div>
    );
  }
}

export default connect(
  state => ({
    cultivationAdvices: state.cultivationAdvices.items,
    meta: state.cultivationAdvices.meta,
    local: state.app.user.profile.Language
  }),
  {
    getCultivationAdvices: CultivationAdviceActions.getCultivationAdvices,
    onRemove: CultivationAdviceActions.removeCultivationAdvices
  }
)(injectIntl(MyCultivationAdvice));
